// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___7c3e2da62694b12fb16","cls2":"SimplePaperPodcast-cls2___1c1c7c2b10e8529868c SimplePaperPodcast-cls1___7c3e2da62694b12fb16"};